import { Box, Autocomplete, TextField, InputAdornment } from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'
import styles from './styles.module.scss'

const SearchBar = ({ list, handleSearch }) => (
  <Box className={styles.searchContainer}>
    <Autocomplete
      className={styles.search}
      freeSolo
      onInputChange={handleSearch}
      options={list}
      getOptionLabel={(item) => item.name || ''}
      getOptionKey={item => item.id}
      filterOptions={(options, { inputValue }) =>
        options.filter(
          (option) =>
            option.name?.toLowerCase().includes(inputValue.toLowerCase()) ||
            option.url?.toLowerCase().includes(inputValue.toLowerCase())
        )
      }
      onKeyDown={(event) => {
        if (event.key === 'Enter') {
          event.preventDefault()
        }
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          className={styles.searchInput}
          variant="standard"
          placeholder='Search...'
          InputProps={{
            ...params.InputProps,
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      )}
    />
  </Box>
)

export default SearchBar